module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('header', {
    staticClass: "topbar clearfix"
  }, [_c('div', {
    staticClass: "top-search-bar"
  }, [_c('div', {
    staticClass: "search-input-addon"
  }, [_c('span', {
    staticClass: "addon-icon pointer",
    on: {
      "click": function($event) {
        _vm.startSearchKeyWord()
      }
    }
  }, [_c('i', {
    staticClass: "zmdi zmdi-search"
  })]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.keyword),
      expression: "keyword"
    }],
    staticClass: "form-control top-search-input",
    attrs: {
      "type": "text",
      "placeholder": "搜尋關鍵字"
    },
    domProps: {
      "value": (_vm.keyword)
    },
    on: {
      "keyup": function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "enter", 13)) { return null; }
        _vm.searchKeyWord()
      },
      "focus": function($event) {
        _vm.showResult = true
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.keyword = $event.target.value
      }
    }
  }), _vm._v(" "), (_vm.loading == true) ? _c('img', {
    staticClass: "top-search-loading-image",
    attrs: {
      "src": require("../../assets/img/cat/cat-loading.gif")
    }
  }) : _vm._e()])]), _vm._v(" "), (_vm.showResult == true && _vm.searchResult != '') ? _c('div', {
    directives: [{
      name: "click-outside",
      rawName: "v-click-outside",
      value: (_vm.hide),
      expression: "hide"
    }],
    staticClass: "top-search-result"
  }, [_c('ul', {
    staticClass: "nav nav-tabs nav-center",
    attrs: {
      "role": "tablist"
    }
  }, [_c('li', {
    staticClass: "active",
    attrs: {
      "role": "presentation"
    }
  }, [_c('a', {
    attrs: {
      "href": "#all",
      "aria-controls": "deals_result",
      "role": "tab",
      "data-toggle": "tab"
    }
  }, [_vm._v("\n            All (" + _vm._s(_vm.totalSearchResult) + ")\n          ")])]), _vm._v(" "), (_vm.searchResult['Deals'].length != 0) ? _c('li', {
    attrs: {
      "role": "presentation"
    }
  }, [_c('a', {
    attrs: {
      "href": "#deals_result",
      "aria-controls": "deals_result",
      "role": "tab",
      "data-toggle": "tab"
    }
  }, [_c('i', {
    staticClass: "fas fa-dollar-sign"
  }), _vm._v(" (" + _vm._s(_vm.searchResult["Deals"].length) + ")\n          ")])]) : _vm._e(), _vm._v(" "), (_vm.searchResult['Contacts'].length != 0) ? _c('li', {
    attrs: {
      "role": "presentation"
    }
  }, [_c('a', {
    attrs: {
      "href": "#contacts_result",
      "aria-controls": "contacts_result",
      "role": "tab",
      "data-toggle": "tab"
    }
  }, [_c('i', {
    staticClass: "fa fa-user"
  }), _vm._v(" (" + _vm._s(_vm.searchResult["Contacts"].length) + ")\n          ")])]) : _vm._e(), _vm._v(" "), (_vm.searchResult['Organizations'].length != 0) ? _c('li', {
    attrs: {
      "role": "presentation"
    }
  }, [_c('a', {
    attrs: {
      "href": "#organizations_result",
      "aria-controls": "organizations_result",
      "role": "tab",
      "data-toggle": "tab"
    }
  }, [_c('i', {
    staticClass: "fa fa-building"
  }), _vm._v(" (" + _vm._s(_vm.searchResult["Organizations"].length) + ")\n          ")])]) : _vm._e(), _vm._v(" "), (_vm.searchResult['Quotations'].length != 0) ? _c('li', {
    attrs: {
      "role": "presentation"
    }
  }, [_c('a', {
    attrs: {
      "href": "#quotations_result",
      "aria-controls": "quotations_result",
      "role": "tab",
      "data-toggle": "tab"
    }
  }, [_c('i', {
    staticClass: "fa fa-file"
  }), _vm._v(" (" + _vm._s(_vm.searchResult["Quotations"].length) + ")\n          ")])]) : _vm._e(), _vm._v(" "), (_vm.searchResult['Attachments'].length != 0) ? _c('li', {
    attrs: {
      "role": "presentation"
    }
  }, [_c('a', {
    attrs: {
      "href": "#attachments_result",
      "aria-controls": "attachments_result",
      "role": "tab",
      "data-toggle": "tab"
    }
  }, [_c('i', {
    staticClass: "fa fa-paperclip"
  }), _vm._v(" (" + _vm._s(_vm.searchResult["Attachments"].length) + ")\n          ")])]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "tab-content search-panel"
  }, [_c('div', {
    staticClass: "tab-pane active",
    attrs: {
      "role": "tabpanel",
      "id": "all"
    }
  }, [_vm._l((_vm.searchResult['Deals']), function(deal) {
    return _c('div', {
      staticClass: "single-result deal-result pointer"
    }, [_c('div', {
      on: {
        "click": function($event) {
          _vm.ShowDeal(deal.deal_token)
        }
      }
    }, [_vm._m(0, true), _vm._v(" "), _c('div', {
      staticClass: "result-content"
    }, [_c('div', {
      staticClass: "result-title"
    }, [_vm._v(_vm._s(deal.title))]), _vm._v(" "), _c('small', {
      staticClass: "result-subtitle"
    }, [_vm._v(_vm._s(deal.contact.name) + " , $ " + _vm._s(deal.value.toLocaleString()))])]), _vm._v(" "), _c('div', {
      staticClass: "result-status"
    }, [(deal.status == 'won') ? _c('span', {
      staticClass: "label label-success"
    }, [_vm._v("完成")]) : _vm._e(), _vm._v(" "), (deal.status == 'open') ? _c('span', [_vm._v("進行中")]) : _vm._e(), _vm._v(" "), (deal.status == 'lost') ? _c('span', {
      staticClass: "label label-danger"
    }, [_vm._v("失去")]) : _vm._e()])])])
  }), _vm._v(" "), _vm._l((_vm.searchResult['Contacts']), function(contact) {
    return _c('div', {
      staticClass: "single-result deal-result pointer"
    }, [_c('div', {
      on: {
        "click": function($event) {
          _vm.ShowContact(contact.contact_token)
        }
      }
    }, [_vm._m(1, true), _vm._v(" "), _c('div', {
      staticClass: "result-content"
    }, [_c('div', {
      staticClass: "result-title"
    }, [_vm._v(_vm._s(contact.name))]), _vm._v(" "), _c('small', {
      staticClass: "result-subtitle"
    }, [_vm._v(_vm._s(contact.email || '無email') + " , " + _vm._s(contact.phone || '無手機') + "," + _vm._s(contact.organization.name))])])])])
  }), _vm._v(" "), _vm._l((_vm.searchResult['Organizations']), function(organization) {
    return _c('div', {
      staticClass: "single-result deal-result pointer"
    }, [_c('div', {
      on: {
        "click": function($event) {
          _vm.ShowOrganization(organization.organization_token)
        }
      }
    }, [_vm._m(2, true), _vm._v(" "), _c('div', {
      staticClass: "result-content"
    }, [_c('div', {
      staticClass: "result-title"
    }, [_vm._v(_vm._s(organization.name))]), _vm._v(" "), (organization.address) ? _c('small', {
      staticClass: "result-subtitle"
    }, [_vm._v(_vm._s(organization.address))]) : _c('small', {
      staticClass: "result-subtitle"
    }, [_vm._v("無地址")])])])])
  }), _vm._v(" "), _vm._l((_vm.searchResult['Quotations']), function(quotation) {
    return _c('div', {
      staticClass: "single-result deal-result pointer"
    }, [_c('div', {
      on: {
        "click": function($event) {
          _vm.ShowQuotation(quotation.quotation_token)
        }
      }
    }, [_vm._m(3, true), _vm._v(" "), _c('div', {
      staticClass: "result-content"
    }, [_c('div', {
      staticClass: "result-title"
    }, [_vm._v("報價單：" + _vm._s(quotation.title))]), _vm._v(" "), _c('small', {
      staticClass: "result-subtitle"
    }, [_vm._v(_vm._s(quotation.deal.title) + " , 總金額: $" + _vm._s((quotation.total_price || 0).toLocaleString()))])]), _vm._v(" "), _vm._m(4, true)])])
  }), _vm._v(" "), _vm._l((_vm.searchResult['Attachments']), function(activity) {
    return _c('div', {
      staticClass: "single-result deal-result pointer"
    }, [_c('div', {
      on: {
        "click": function($event) {
          _vm.DownLoadFile(activity.attachment_url)
        }
      }
    }, [_vm._m(5, true), _vm._v(" "), _c('div', {
      staticClass: "result-content"
    }, [_c('div', {
      staticClass: "result-title"
    }, [_vm._v(_vm._s(activity.title))]), _vm._v(" "), _c('small', {
      staticClass: "result-subtitle"
    }, [_vm._v("專案:" + _vm._s(activity.deal.title))])])])])
  }), _vm._v(" "), (_vm.totalSearchResult == 0) ? _c('div', {
    staticClass: "single-result deal-result pointer"
  }, [_c('div', {
    staticStyle: {
      "padding": "15px"
    }
  }, [_vm._v("無任何搜尋結果")])]) : _vm._e()], 2), _vm._v(" "), _c('div', {
    staticClass: "tab-pane",
    attrs: {
      "role": "tabpanel",
      "id": "deals_result"
    }
  }, [_vm._l((_vm.searchResult['Deals']), function(deal) {
    return _c('div', {
      staticClass: "single-result deal-result pointer"
    }, [_c('div', {
      on: {
        "click": function($event) {
          _vm.ShowDeal(deal.deal_token)
        }
      }
    }, [_vm._m(6, true), _vm._v(" "), _c('div', {
      staticClass: "result-content"
    }, [_c('div', {
      staticClass: "result-title"
    }, [_vm._v(_vm._s(deal.title))]), _vm._v(" "), _c('small', {
      staticClass: "result-subtitle"
    }, [_vm._v(_vm._s(deal.contact.name) + " , $ " + _vm._s(deal.value.toLocaleString()))])]), _vm._v(" "), _c('div', {
      staticClass: "result-status"
    }, [(deal.status == 'won') ? _c('span', {
      staticClass: "label label-success"
    }, [_vm._v("完成")]) : _vm._e(), _vm._v(" "), (deal.status == 'open') ? _c('span', [_vm._v("進行中")]) : _vm._e(), _vm._v(" "), (deal.status == 'lost') ? _c('span', {
      staticClass: "label label-danger"
    }, [_vm._v("失去")]) : _vm._e()])])])
  }), _vm._v(" "), (_vm.searchResult['Deals'].length == 0) ? _c('div', {
    staticClass: "single-result deal-result pointer"
  }, [_c('div', {
    staticStyle: {
      "padding": "15px"
    }
  }, [_vm._v("無相關交易")])]) : _vm._e()], 2), _vm._v(" "), _c('div', {
    staticClass: "tab-pane",
    attrs: {
      "role": "tabpanel",
      "id": "contacts_result"
    }
  }, [_vm._l((_vm.searchResult['Contacts']), function(contact) {
    return _c('div', {
      staticClass: "single-result deal-result pointer"
    }, [_c('div', {
      on: {
        "click": function($event) {
          _vm.ShowContact(contact.contact_token)
        }
      }
    }, [_vm._m(7, true), _vm._v(" "), _c('div', {
      staticClass: "result-content"
    }, [_c('div', {
      staticClass: "result-title"
    }, [_vm._v(_vm._s(contact.name))]), _vm._v(" "), _c('small', {
      staticClass: "result-subtitle"
    }, [_vm._v(_vm._s(contact.email || '無email') + " , " + _vm._s(contact.phone || '無手機') + "," + _vm._s(contact.organization.name))])])])])
  }), _vm._v(" "), (_vm.searchResult['Contacts'].length == 0) ? _c('div', {
    staticClass: "single-result deal-result pointer"
  }, [_c('div', {
    staticStyle: {
      "padding": "15px"
    }
  }, [_vm._v("無相關聯絡人")])]) : _vm._e()], 2), _vm._v(" "), _c('div', {
    staticClass: "tab-pane",
    attrs: {
      "role": "tabpanel",
      "id": "organizations_result"
    }
  }, [_vm._l((_vm.searchResult['Organizations']), function(organization) {
    return _c('div', {
      staticClass: "single-result deal-result pointer"
    }, [_c('div', {
      on: {
        "click": function($event) {
          _vm.ShowOrganization(organization.organization_token)
        }
      }
    }, [_vm._m(8, true), _vm._v(" "), _c('div', {
      staticClass: "result-content"
    }, [_c('div', {
      staticClass: "result-title"
    }, [_vm._v(_vm._s(organization.name))]), _vm._v(" "), (organization.address) ? _c('small', {
      staticClass: "result-subtitle"
    }, [_vm._v(_vm._s(organization.address))]) : _c('small', {
      staticClass: "result-subtitle"
    }, [_vm._v("無地址")])])])])
  }), _vm._v(" "), (_vm.searchResult['Organizations'].length == 0) ? _c('div', {
    staticClass: "single-result deal-result pointer"
  }, [_c('div', {
    staticStyle: {
      "padding": "15px"
    }
  }, [_vm._v("無相關組織")])]) : _vm._e()], 2), _vm._v(" "), _c('div', {
    staticClass: "tab-pane",
    attrs: {
      "role": "tabpanel",
      "id": "quotations_result"
    }
  }, [_vm._l((_vm.searchResult['Quotations']), function(quotation) {
    return _c('div', {
      staticClass: "single-result deal-result pointer"
    }, [_c('div', {
      on: {
        "click": function($event) {
          _vm.ShowQuotation(quotation.quotation_token)
        }
      }
    }, [_vm._m(9, true), _vm._v(" "), _c('div', {
      staticClass: "result-content"
    }, [_c('div', {
      staticClass: "result-title"
    }, [_vm._v("報價單：" + _vm._s(quotation.title))]), _vm._v(" "), _c('small', {
      staticClass: "result-subtitle"
    }, [_vm._v(_vm._s(quotation.deal.title) + " , 總金額: $" + _vm._s((quotation.total_price || 0).toLocaleString()))])]), _vm._v(" "), _vm._m(10, true)])])
  }), _vm._v(" "), (_vm.searchResult['Quotations'].length == 0) ? _c('div', {
    staticClass: "single-result deal-result pointer"
  }, [_c('div', {
    staticStyle: {
      "padding": "15px"
    }
  }, [_vm._v("無相關報價單")])]) : _vm._e()], 2), _vm._v(" "), _c('div', {
    staticClass: "tab-pane",
    attrs: {
      "role": "tabpanel",
      "id": "attachments_result"
    }
  }, [_vm._l((_vm.searchResult['Attachments']), function(activity) {
    return _c('div', {
      staticClass: "single-result deal-result pointer"
    }, [_c('div', {
      on: {
        "click": function($event) {
          _vm.DownLoadFile(activity.attachment_url)
        }
      }
    }, [_vm._m(11, true), _vm._v(" "), _c('div', {
      staticClass: "result-content"
    }, [_c('div', {
      staticClass: "result-title"
    }, [_vm._v(_vm._s(activity.title))]), _vm._v(" "), _c('small', {
      staticClass: "result-subtitle"
    }, [_vm._v("專案:" + _vm._s(activity.deal.title))])])])])
  }), _vm._v(" "), (_vm.searchResult['Attachments'].length == 0) ? _c('div', {
    staticClass: "single-result deal-result pointer"
  }, [_c('div', {
    staticStyle: {
      "padding": "15px"
    }
  }, [_vm._v("無相關檔案")])]) : _vm._e()], 2)])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "topbar-left pull-left"
  }, [_c('div', {
    staticClass: "clearfix"
  }, [_c('ul', {
    staticClass: "left-branding pull-left clickablemenu ttmenu dark-style menu-color-gradient"
  }, [_c('li', [_c('span', {
    staticClass: "left-toggle-switch",
    staticStyle: {
      "touch-action": "pan-y",
      "user-select": "none",
      "-webkit-user-drag": "none",
      "-webkit-tap-highlight-color": "rgba(0, 0, 0, 0)"
    },
    on: {
      "click": _vm.toggle
    }
  }, [_c('i', {
    staticClass: "zmdi zmdi-menu"
  })])]), _vm._v(" "), _c('li', [_c('div', {
    staticClass: "logo"
  }, [_c('a', {
    staticClass: "pointer",
    on: {
      "click": _vm.GoDashbaord
    }
  }, [_c('img', {
    staticStyle: {
      "margin-top": "7px"
    },
    attrs: {
      "src": require("../../assets/img/logo-white.png"),
      "alt": "logo",
      "height": "46"
    }
  })])])])]), _vm._v(" "), _vm._m(12)])]), _vm._v(" "), _c('div', {
    staticClass: "topbar-right pull-right"
  }, [_c('div', {
    staticClass: "clearfix"
  }, [_vm._m(13), _vm._v(" "), _c('ul', {
    staticClass: "pull-right top-right-icons"
  }, [_vm._m(14), _vm._v(" "), _c('li', {
    staticClass: "dropdown more-dropdown topbar-logged-user"
  }, [_c('a', {
    staticClass: "dropdown-toggle",
    attrs: {
      "href": "#",
      "data-toggle": "dropdown"
    }
  }, [(!_vm.user.profile_pic) ? _c('img', {
    staticClass: "pointer",
    attrs: {
      "src": require("../../assets/img/logo1.png"),
      "alt": "admin"
    }
  }) : _c('img', {
    staticClass: "pointer",
    attrs: {
      "src": _vm.user.profile_pic,
      "alt": "admin"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "dropdown-menu more-apps"
  }, [_c('div', {
    staticClass: "user-profile-container"
  }, [_c('div', {
    staticClass: "user-profile clearfix pointer",
    on: {
      "click": _vm.GoUserProfile
    }
  }, [_c('div', {
    staticClass: "admin-user-thumb"
  }, [(!_vm.user.profile_pic) ? _c('img', {
    staticClass: "pointer",
    attrs: {
      "src": require("../../assets/img/logo1.png"),
      "alt": "admin"
    }
  }) : _c('img', {
    staticClass: "pointer",
    attrs: {
      "src": _vm.user.profile_pic,
      "alt": "admin"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "admin-user-info"
  }, [_c('ul', [_c('li', [_c('a', [_vm._v(_vm._s(_vm.user.name))])]), _vm._v(" "), _c('li', [_c('a', [_vm._v(_vm._s(_vm.user.email))])])])])])]), _vm._v(" "), _c('ul', {
    staticClass: "more-apps"
  }, [_c('li', {
    on: {
      "click": function($event) {
        _vm.GoUserProfile()
      }
    }
  }, [_vm._m(15)]), _vm._v(" "), (_vm.user.permission == 'admin') ? _c('li', {
    on: {
      "click": function($event) {
        _vm.goBills()
      }
    }
  }, [_vm._m(16)]) : _vm._e(), _vm._v(" "), (_vm.user.permission == 'admin') ? _c('li', {
    on: {
      "click": function($event) {
        _vm.goCreditCard()
      }
    }
  }, [_vm._m(17)]) : _vm._e(), _vm._v(" "), _c('li', {
    on: {
      "click": function($event) {
        _vm.logout()
      }
    }
  }, [_vm._m(18)])])])])])])])]), _vm._v(" "), _c('LeftSideBar', {
    key: _vm.urlKey(),
    staticClass: "left-aside-default",
    class: {
      'left-aside-open': _vm.toggle_aside
    },
    attrs: {
      "user": _vm.user
    }
  }), _vm._v(" "), (_vm.checkUserTutorStatus()) ? _c('TutorSteps', {
    attrs: {
      "user": _vm.user
    }
  }) : _vm._e()], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "result-icon"
  }, [_c('i', {
    staticClass: "fas fa-dollar-sign"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "result-icon"
  }, [_c('img', {
    staticClass: "img-thumbnail img-circle",
    staticStyle: {
      "border": "none"
    },
    attrs: {
      "src": require("../../assets/img/no-avatar.jpg")
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "result-icon"
  }, [_c('i', {
    staticClass: "fa fa-building"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "result-icon"
  }, [_c('i', {
    staticClass: "fa fa-file"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "result-status"
  }, [_c('span', {
    staticClass: "label label-success"
  }, [_vm._v("won")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "result-icon"
  }, [_c('i', {
    staticClass: "fa fa-paperclip"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "result-icon"
  }, [_c('i', {
    staticClass: "fas fa-dollar-sign"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "result-icon"
  }, [_c('img', {
    staticClass: "img-thumbnail img-circle",
    staticStyle: {
      "border": "none"
    },
    attrs: {
      "src": require("../../assets/img/no-avatar.jpg")
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "result-icon"
  }, [_c('i', {
    staticClass: "fa fa-building"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "result-icon"
  }, [_c('i', {
    staticClass: "fa fa-file"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "result-status"
  }, [_c('span', {
    staticClass: "label label-success"
  }, [_vm._v("won")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "result-icon"
  }, [_c('i', {
    staticClass: "fa fa-paperclip"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ul', {
    staticClass: "branding-right pull-right"
  }, [_c('li', [_c('a', {
    staticClass: "btn-mobile-search btn-top-search",
    staticStyle: {
      "touch-action": "pan-y",
      "user-select": "none",
      "-webkit-user-drag": "none",
      "-webkit-tap-highlight-color": "rgba(0, 0, 0, 0)"
    },
    attrs: {
      "href": "#"
    }
  }, [_c('i', {
    staticClass: "zmdi zmdi-search"
  })])]), _vm._v(" "), _c('li', [_c('a', {
    staticClass: "btn-mobile-bar",
    staticStyle: {
      "touch-action": "pan-y",
      "user-select": "none",
      "-webkit-user-drag": "none",
      "-webkit-tap-highlight-color": "rgba(0, 0, 0, 0)"
    },
    attrs: {
      "href": "#"
    }
  }, [_c('i', {
    staticClass: "zmdi zmdi-menu"
  })])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ul', {
    staticClass: "left-bar-switch pull-left"
  }, [_c('li', [_c('span', {
    staticClass: "left-toggle-switch",
    staticStyle: {
      "touch-action": "pan-y",
      "user-select": "none",
      "-webkit-user-drag": "none",
      "-webkit-tap-highlight-color": "rgba(0, 0, 0, 0)"
    }
  }, [_c('i', {
    staticClass: "zmdi zmdi-menu"
  })])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', {
    staticClass: "dropdown notifications-dropdown mr-3"
  }, [_c('div', {
    staticClass: "dropdown-menu notifications-tabs"
  }, [_c('div', [_c('div', {
    staticClass: "notification-wrap"
  }, [_c('h4', [_vm._v("你有 10 個通知")]), _vm._v(" "), _c('ul', [_c('li', [_c('a', {
    staticClass: "clearfix",
    attrs: {
      "href": "#"
    }
  }, [_c('span', {
    staticClass: "ni w_bg_purple"
  }, [_c('i', {
    staticClass: "fa fa-bullhorn"
  })]), _c('span', {
    staticClass: "notification-message"
  }, [_vm._v("Pellentesque semper posuere. "), _c('span', {
    staticClass: "notification-time clearfix"
  }, [_vm._v("3 Min Ago")])])])]), _vm._v(" "), _c('li', [_c('a', {
    staticClass: "clearfix",
    attrs: {
      "href": "#"
    }
  }, [_c('span', {
    staticClass: "ni w_bg_orange"
  }, [_c('i', {
    staticClass: "fa fa-life-ring"
  })]), _c('span', {
    staticClass: "notification-message"
  }, [_vm._v("Nulla commodo sem at purus. "), _c('span', {
    staticClass: "notification-time clearfix"
  }, [_vm._v("1 Hours Ago")])])])]), _vm._v(" "), _c('li', [_c('a', {
    staticClass: "clearfix",
    attrs: {
      "href": "#"
    }
  }, [_c('span', {
    staticClass: "ni w_bg_red"
  }, [_c('i', {
    staticClass: "fa fa-star-o"
  })]), _c('span', {
    staticClass: "notification-message"
  }, [_vm._v("Fusce condimentum turpis. "), _c('span', {
    staticClass: "notification-time clearfix"
  }, [_vm._v("3 Hours Ago")])])])]), _vm._v(" "), _c('li', [_c('a', {
    staticClass: "clearfix",
    attrs: {
      "href": "#"
    }
  }, [_c('span', {
    staticClass: "ni w_bg_light_blue"
  }, [_c('i', {
    staticClass: "fa fa-trophy"
  })]), _c('span', {
    staticClass: "notification-message"
  }, [_vm._v("Pellentesque habitant morbi. "), _c('span', {
    staticClass: "notification-time clearfix"
  }, [_vm._v("Yesterday")])])])]), _vm._v(" "), _c('li', [_c('a', {
    staticClass: "clearfix",
    attrs: {
      "href": "#"
    }
  }, [_c('span', {
    staticClass: "ni w_bg_cyan"
  }, [_c('i', {
    staticClass: "fa fa-bolt"
  })]), _c('span', {
    staticClass: "notification-message"
  }, [_vm._v("Fusce bibendum lacus mauris."), _c('span', {
    staticClass: "notification-time clearfix"
  }, [_vm._v("1 Month Ago")])])])]), _vm._v(" "), _c('li', [_c('a', {
    staticClass: "clearfix",
    attrs: {
      "href": "#"
    }
  }, [_c('span', {
    staticClass: "ni w_bg_yellow"
  }, [_c('i', {
    staticClass: "fa fa-bookmark-o"
  })]), _c('span', {
    staticClass: "notification-message"
  }, [_vm._v("Donec id mi placerat, scelerisque."), _c('span', {
    staticClass: "notification-time clearfix"
  }, [_vm._v("3 Months Ago")])])])])]), _vm._v(" "), _c('a', {
    staticClass: "btn btn-link btn-block btn-view-all clearfix",
    attrs: {
      "href": "#"
    }
  }, [_c('span', [_vm._v("View All")])])])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    attrs: {
      "href": "#"
    }
  }, [_c('i', {
    staticClass: "far fa-user-circle"
  }), _vm._v(" 個人資料")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    attrs: {
      "href": "#"
    }
  }, [_c('i', {
    staticClass: "fa fa-file-invoice-dollar"
  }), _vm._v(" 帳單一覽")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    attrs: {
      "href": "#"
    }
  }, [_c('i', {
    staticClass: "far fa-credit-card"
  }), _vm._v(" 方案與付款方式")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    attrs: {
      "href": "#"
    }
  }, [_c('i', {
    staticClass: "zmdi zmdi-power"
  }), _vm._v(" 登出")])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-86e644b4","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Common/TopBar.vue
// module id = 702
// module chunks = 4